<script lang="ts" setup>
  import { ExternalRoute } from "@/constants/externalRoute"
  import Link from "@/components/ui/link/Link.vue"
</script>
<template>
  <h4>It's worth trying this before you go</h4>

  <p>
    It's easy to manage your energy account online. From the
    <Link :to="ExternalRoute.personalDetails" class="link text-primary-600">
      Personal Details
    </Link>
    page of your account you can:
  </p>
  <ul class="list-disc pl-7">
    <li>Change your email address</li>
    <li>Change your password</li>
    <li>Add additional phone numbers to your account</li>
    <li>Choose your favourite energy source</li>
    <li>Update your communication preferences</li>
    <li>Set up meter reading reminders</li>
  </ul>

  <p>
    We hope this helped with your issue, but if not you can continue to cancel
    your switch.
  </p>
</template>
